import background from '../../assests/internship/intern-background-home.png'
import internship2 from '../../assests/internship/internship-home2.png'
import internship5 from '../../assests/internship/internship-home4.png'
import image1 from '../../assests/internship/Live coaching.png'
import image2 from '../../assests/internship/Beginner Level.png'
import image3 from '../../assests/internship/Official Certification.png'
import image4 from '../../assests/internship/One-on-one sessions.png'
import image5 from '../../assests/internship/placement assistance.png'
import image6 from '../../assests/internship/Top Industry Trainers.png'
import person2 from '../../assests/internship/person2.png'
import './internship.css'
import Header from '../componets/header/header'
import Footer from '../componets/footer/footer'
import { FacebookFilled, InstagramOutlined, LinkedinFilled, WhatsAppOutlined, YoutubeOutlined } from '@ant-design/icons'

import about from "../../assests/about_image.png";
function Internship() {
    const handleDownload = () => {
        const pdfUrl = new URL("../../assests/internship/Internship_Brochure.pdf", import.meta.url).href;
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = "Internship_Brochure.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const syllabusItems = [
        ['Digital Marketing Introduction', 'Website Planning', 'Wordpress Management', 'Search Engine Marketing', 'Blog Writing & Publishing', 'Campaign Management & Reporting', 'Affiliate Marketing', 'Media Planning & Buying', 'Agency Orientation'],
        ['Digital Marketing Overview', 'Design Essentials', 'Advanced Keyword Research', 'Google Analytics', 'Social Media Marketing', 'Online Reputation Management', 'Email Marketing', 'Marketing Automation'],
        ['Inbound Marketing', 'Web Design & Development', 'Search Engine Optimization', 'Content Marketing Strategy', 'Lead Generation Campaign', 'Google Adsense', 'Influencer Marketing', 'Introduction to E-Commerce'],
    ];
    return (
        <div>
            <Header />
            <div >
                <section className="hero">
                    <div className="text_values">

                        <h1>Global Digital Marketing Education, Powered by Papa Digital Academy</h1>


                        <div className="social-icons">
                            <a href='https://www.facebook.com/papadigitalsolution' target="_blank" rel="noopener noreferrer">
                                <FacebookFilled style={{ color: "white" }} />
                            </a>
                            <a href='https://www.instagram.com/papaekmpapa/' target="_blank" rel="noopener noreferrer">
                                <InstagramOutlined className="fab fa-instagram" style={{ color: "white" }} />
                            </a>
                            <a href='https://www.youtube.com/@Papadigitalsolution' target="_blank" rel="noopener noreferrer">
                                <YoutubeOutlined className="fab fa-youtube" style={{ color: "white" }} />
                            </a>
                            <a href='https://www.linkedin.com/company/papa-digital-solution/posts/?feedView=all' target="_blank" rel="noopener noreferrer">
                                <LinkedinFilled className="fab fa-linkedin-in" style={{ color: "white" }} />
                            </a>
                            <a href='https://wa.me/919562121117' target="_blank" rel="noopener noreferrer">
                                <WhatsAppOutlined className="fab fa-whatsapp" style={{ color: "white" }} />
                            </a>
                        </div>
                    </div>

                    <img src={background} alt="Group of Students" style={{
                        position: 'absolute',
                        bottom: 0,
                        maxWidth: '100%',
                        height: 'auto',
                        zIndex: 2,
                    }} />


                </section>
                <section className="overlay-section">
                    <img src={internship2} alt="Digital Marketing" className="background-image" />
                    <div className="overlay-content">
                        <h2>Best Online Digital Marketing Courses in India</h2>
                        <p>At Papa Digital Academy, we help individuals transform their careers through industry-focused
                            digital marketing training. Our live online courses are
                            designed to give you hands-on experience with real-world
                            strategies used by top digital agencies.

                            Many of our students have seen fast-track growth—whether landing their first job,
                            switching careers, or securing promotions. Our curriculum is built to match the needs
                            of the modern digital landscape, helping
                            learners gain the skills employers are actively looking for.
                        </p>
                        <p>
                            What makes Papa Digital Academy stand out is the value it brings to your
                            career. As your skills improve, so do your job opportunities and earning potential.
                            Our learners often see significant salary growth after completing
                            the program, making their investment both smart and rewarding.

                            Join Papa Digital Academy and take the next big step toward a successful, future-proof career in digital marketing.
                        </p>
                    </div>
                </section>
                <section className="course-audience-section">
                    <h2>WHO SHOULD ATTEND THE COURSE</h2>
                    <div className="audience-cards-container">
                        <div className="audience-card">
                            <span className="card-number">1</span>
                            <h3>For Students & Graduates</h3>
                            <h4>Jumpstart Your Career!</h4>
                            <p>
                                Are you ready to be the next in-demand Digital Marketing Professional? Dive into our comprehensive
                                courses designed to catapult you into the job market with the hottest digital skills under your belt.
                                Let's turn your potential into success!
                            </p>
                        </div>

                        <div className="audience-card">
                            <span className="card-number">2</span>
                            <h3>For Homemakers</h3>
                            <h4>Reignite Your Career Path!</h4>
                            <p>
                                Thinking of re-entering the workforce or starting fresh? Our flexible digital marketing programs are perfect for
                                gaining the skills you need at your own pace. Empower yourself to step back into your career with confidence
                                and creativity!
                            </p>
                        </div>

                        <div className="audience-card">
                            <span className="card-number">3</span>
                            <h3>For Working Professionals</h3>
                            <h4>Advance Your Career!</h4>
                            <p>
                                Feel stuck in your current role? It's time to up-skill and make a leap towards that dream career with our
                                cutting-edge digital marketing training. Enhance your resume and your prowess, and watch new doors
                                open as you transform your professional life!
                            </p>
                        </div>

                        <div className="audience-card">
                            <span className="card-number">4</span>
                            <h3>For Entrepreneurs</h3>
                            <h4>Skyrocket Your Business!</h4>
                            <p>
                                Ready to take your business to the next level? Learn how to attract high-ticket clients and significantly
                                boost your revenue through targeted, effective digital marketing strategies. Join us and start seeing your
                                business grow like never before!
                            </p>
                        </div>
                        <div className="audience-card">
                            <span className="card-number">5</span>
                            <h3>For Web Development Enthusiasts</h3>
                            <h4>Build the Digital Future!</h4>
                            <p>
                                Interested in creating stunning websites and powerful web applications? Our courses provide the foundational
                                and advanced skills in web development to turn your ideas into reality. Whether you're a beginner or looking
                                to expand your expertise, join us to master the art of web development!
                            </p>
                        </div>
                        <div className="audience-card">
                            <span className="card-number">6</span>
                            <h3>For Digital & Social Media Users</h3>
                            <h4>Level Up Your Online Presence!</h4>
                            <p>
                                Do you spend time on social media or use digital tools daily? Transform your basic knowledge into powerful
                                skills! Discover how to strategically use digital platforms for personal branding, community building, or even
                                to kickstart a new venture. Unlock the full potential of the digital world!
                            </p>
                        </div>
                    </div>
                </section>
                <div className="about-section-wrapper">
                    <div className="about-left">
                        <div className="internship-images">
                            <img src={person2} alt="internship-home" />
                        </div>

                    </div>


                    <div className="about-right">
                        <h6 className="about-subtitle">About Us</h6>
                        <h2 className="about-title">
                            WHO WE ARE
                        </h2>
                        <div className="about-summary">

                            <div className="about-description">
                                <p>
                                    At Papa Digital Academy, we are more than just a technology company - we are your trusted
                                    partners in navigating the digital landscape.
                                    Our mission is to empower businesses and individuals by providing innovative, tailored digital
                                    solutions that drive growth, efficiency, and success.
                                </p>
                                <p>
                                    Founded on the principles of creativity, collaboration, and customer-centricity, we pride
                                    ourselves on delivering exceptional value through cutting-edge technology and expert
                                    guidance. Our parent company is helmed by marketing professionals with more than 5+ years
                                    of experience in creative marketing and tech realms. With such vast expertise behind us, papa
                                    digital solution aims to become the go-to destination for students, job seekers, and
                                    professionals looking to boost their digital marketing skills and career prospects.
                                </p>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="internship-offer-section">
                    <div className="internship-home3">
                        <div className="internship-images">
                            <img src={internship5} alt="internship-home" />
                        </div>

                        <div className="internship-texts">
                            <h2 className="about-title">WHAT WE OFFER</h2>
                            <div className="about-description">
                                <p>
                                    At Papa Digital Academy, we do more than just teach—you'll receive mentorship, coaching,
                                    and career guidance from industry professionals who've walked the walk. Our goal is to raise
                                    the bar for local talent by building a culture of professionalism, creativity, and excellence.
                                    Here's how we do it:
                                </p>
                                <ul>
                                    <li>
                                        <strong>Live Projects & Hands-on Training:</strong> Our unique formula allows you to learn by doing.
                                        You'll work on live projects, gaining real-world experience as you train.
                                    </li>
                                    <li>
                                        <strong>Work Ethics & Professionalism:</strong> We're big on work ethics! At Papa Digital Academy,
                                        we emphasize professionalism and dedication, ensuring our students develop the mindset needed to excel.
                                    </li>
                                    <li>
                                        <strong>Mentorship & Coaching:</strong> You won't just attend classes—you'll be guided by experts with
                                        years of industry experience, giving you insights and personalized support throughout your journey.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="timings-section">
                    <h2 className="about-title">TIMINGS</h2>
                    <div className="timings-top">
                        <div className="timing-box">
                            <div className="timing-icon">🕒</div>
                            <p><strong>MON–FRI, 2 hours live classes.</strong></p>
                        </div>
                        <div className="timing-box">
                            <div className="timing-icon">🕒</div>
                            <p><strong>3 Months of Practicing & Proven Training Method</strong></p>
                        </div>
                    </div>

                    <div className="timings-features">
                        {[
                            { icon: image1, text: 'Live coaching' },
                            { icon: image2, text: 'Beginner Level' },
                            { icon: image3, text: 'Official Certification' },
                            { icon: image4, text: 'One-on-one sessions' },
                            { icon: image5, text: '100% placement assistance' },
                            { icon: image6, text: 'Top Industry Trainers' },
                        ].map((feature, index) => (
                            <div className="feature-item" key={index}>
                                <div className="feature-icon">
                                    <img src={feature.icon} alt={feature.text} style={{ width: 32, height: 32 }} />
                                </div>
                                <p>{feature.text}</p>
                            </div>
                        ))}
                    </div>

                </section>
                <div className="whatweoffer-container">
                    <div className="offer-image">
                        <img src={about} alt="What We Offer" />
                    </div>
                    <div className="offer-content">
                        <h2>Why Join Us?</h2>
                        <ul>
                            <li> Real-world experience through live projects</li>
                            <li> Mentorship from industry experts</li>
                            <li>Flexible learning for students, professionals, and entrepreneurs</li>
                            <li>Opportunities to grow in digital marketing and beyond</li>
                            <p>At papa digital Academy, we believe in the power of innovation and the
                                importance of quality education. Join us, and let's build a bright, successful
                                future together!</p>
                        </ul>
                    </div>
                </div>
                <section className="syllabus-section">
                    <h2 className="about-title">SYLLABUS</h2>
                    <div className="syllabus-columns">
                        {syllabusItems.map((column, colIndex) => (
                            <ul className="syllabus-column" key={colIndex}>
                                {column.map((item, index) => (
                                    <li key={index} className="syllabus-item">
                                        <span className="syllabus-icon">🎓</span>
                                        <span>{item}</span>
                                    </li>
                                ))}
                            </ul>
                        ))}
                    </div>
                </section>

                <div>
                    <h3 onClick={handleDownload} className="blinking-text">
                        For More Info <span style={{ color: "#00aaff" }}>CLICK HERE</span>
                    </h3>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Internship
